import React, { useEffect, useState } from 'react';
import {
  Alert,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Stack,
  Typography,
} from '@mui/material';
import { getLastInventoryMail } from '../../../../api/inventoryCountingApi';

function formatDate(value) {
  if (!value) return '-';
  return new Date(value).toLocaleString('pl-PL');
}

export default function LastMailStatusCard({ refreshKey }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadLastMail = async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await getLastInventoryMail();
      setData(result);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.message ||
          'Nie udało się pobrać statusu ostatniego maila.',
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLastMail();
  }, [refreshKey]);

  if (loading) return <CircularProgress size={24} />;

  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 2 }}>
        {error}
      </Alert>
    );
  }

  if (!data) {
    return (
      <Card variant="outlined" sx={{ mt: 3 }}>
        <CardContent>
          <Typography variant="h6">Ostatni mail</Typography>
          <Typography variant="body2" color="text.secondary">
            Brak historii wysyłek.
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card variant="outlined" sx={{ mt: 3 }}>
      <CardContent>
        <Stack spacing={1}>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="h6">Ostatni mail</Typography>

            <Chip
              size="small"
              label={data.status}
              color={data.status === 'SUCCESS' ? 'success' : 'error'}
            />
          </Stack>

          <Typography variant="body2" color="text.secondary">
            Wysłano: {formatDate(data.sentAt)}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Zakres: {formatDate(data.fromDate)} - {formatDate(data.toDate)}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Odbiorcy: {data.recipients || '-'}
          </Typography>

          {data.errorMessage && (
            <Alert severity="error" sx={{ mt: 1 }}>
              {data.errorMessage}
            </Alert>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
